import { AxiosResponse } from 'axios';
import {
  BookLendinRequestBody,
  BookLendOutRequestBody,
  BookLendResponse,
  BookQueryParams,
  BooksApiResponse,
  CreateBooksApiResponse,
  DeleteBookRequestBody,
  DeleteBookResponseBody,
  GenreResponse,
  IBulkUploadResponse,
  ICreateBookRequestBody,
  IUpdateBookRequest,
  UpdateBookApiResponse,
} from '../../interface/libraryManagement';
import api from '../api';
import apiMultipart from '../api-multipart';

export const allBookData = async (params: BookQueryParams): Promise<BooksApiResponse> => {
  const response = await api.get<BooksApiResponse>('/book', { params });

  return response.data;
};

export const postBook = async (
  payload: ICreateBookRequestBody,
): Promise<CreateBooksApiResponse> => {
  const response = await api.post<CreateBooksApiResponse>('/book', payload);

  return response.data;
};

export const patchBook = async (payload: IUpdateBookRequest): Promise<UpdateBookApiResponse> => {
  const response = await api.patch<UpdateBookApiResponse>(`/book/${payload.id}`, payload.bookData);
  return response.data;
};

export const lendinBook = async (payload: BookLendinRequestBody): Promise<BookLendResponse> => {
  const response = await api.put<BookLendResponse>(`/book/lends/${payload.bookId}`);
  return response.data;
};

export const lendOutBook = async (payload: BookLendOutRequestBody): Promise<BookLendResponse> => {
  const response = await api.post<BookLendResponse>('/book/lends', payload);
  return response.data;
};

export const deleteSelectedBook = async (
  payload: DeleteBookRequestBody,
): Promise<DeleteBookResponseBody> => {
  const response = await api.delete<DeleteBookResponseBody>(`/book/${payload.bookId}`);
  return response.data;
};

export const allGenreTypes = async (): Promise<GenreResponse> => {
  const response = await api.get<GenreResponse>('/book/genre');

  return response.data;
};

export const bulkUpload = async (file: FormData): Promise<IBulkUploadResponse> => {
  const response = await apiMultipart.post<IBulkUploadResponse>('/book/bulk-upload', file);

  return response.data;
};

export const bookTemplate = async () => {
  const response: AxiosResponse<ArrayBuffer> = await api.get('/book/bulk-upload/template', {
    responseType: 'arraybuffer', // ✅ Ensures binary data is handled correctly
  });
  handleDownload(response);
};

const handleDownload = (response: AxiosResponse<ArrayBuffer>): void => {
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const fileUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = 'book bulk upload template.xlsx'; // ✅ Desired filename
  link.click();
  URL.revokeObjectURL(fileUrl);
};
